import axios from './config/axios'
const logFormData = (formData) => {
  return axios
    .post('/api/forms/log-formdata', formData)
    .then(r => r.data)
}
export default logFormData

